// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-up-down-3"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.5 8.5L7.49999 4.5L11.5 8.5M7.49999 5.75L7.49999 14.5M12.5 15.5L16.5 19.5L20.5 15.5M16.5 18.25L16.5 9.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowUpDown3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-up-down-3',
    ref,
    icon: element,
  },
));

ArrowUpDown3Icon.displayName = 'ArrowUpDown3Icon';

export default ArrowUpDown3Icon;
